// 厦门域名host
export const xiamenEnvHost: {
  [key: string]: string;
} = {
  dev: 'www-dev.xmsxzx.com',
  pro: 'www.xmsxzx.com'
};

/**
 * 根据访问的域名识别环境（开发-dev,生产-pro）
 * 目前只有dev和pro环境，后端如增加额外环境需要重构此方法
 */
export function getEnv() {
  let env = 'dev';
  const url = window.location.href;
  env = url.indexOf('-dev') >= 0 || url.indexOf('dev-') >= 0 ? 'dev' : 'pro';
  return env;
}

// ICP配置项以及网站title配置项
export const domainNameIcpConfig: {
  [key: string]: {
    thisSiteTitle: string;
    thisSiteIcpName: string;
    thisSiteSubjectCompany: string;
    thisSiteOperatingCompany: string;
    thisSiteIcpUrl: string;
    isShowPublicNetwork: boolean;
    publicNetworkName?: string;
    publicNetworkUrl?: string;
    isShowIcpPermit: boolean;
    icpPermitName?: string;
    icpPermitUrl?: string;
  };
} = {
  [xiamenEnvHost[getEnv()]]: {
    // 当前站点title
    thisSiteTitle: '厦门随享致行科技有限公司',
    // 当前站点icp名称
    thisSiteIcpName: '闽ICP备2023003701号-1',
    // 当前站点主体公司
    thisSiteSubjectCompany: '厦门随享致行科技有限公司',
    // 当前站点运营公司
    thisSiteOperatingCompany: '厦门随享致行科技有限公司运营',
    // 当前站点icp跳转地址
    thisSiteIcpUrl: 'https://beian.miit.gov.cn/#/Integrated/index',
    // 是否展示公网安备
    isShowPublicNetwork: true,
    // 公网安备展示名称
    publicNetworkName: '闽公网安备35020502000762',
    // 公网安备跳转地址
    publicNetworkUrl: 'https://beian.mps.gov.cn/#/query/webSearch?code=35020502000762',
    // 是否展示icp许可证
    isShowIcpPermit: true,
    // icp许可证展示名称
    icpPermitName: '闽B2-20230430',
    // icp许可证跳转地址
    icpPermitUrl:
      'https://dxzhgl.miit.gov.cn/dxxzsp/xkz/xkzgl/resource/qiyesearch.jsp?num=%25E9%2597%25BDB2-20230430&type=xuke'
  },
  // 默认的配置项
  default: {
    // 当前站点title
    thisSiteTitle: '广州宸祺汽车服务有限公司',
    // 当前站点icp名称
    thisSiteIcpName: '粤ICP备2024274297号-1',
    // 当前站点主体公司
    thisSiteSubjectCompany: '广州宸祺汽车服务有限公司',
    // 当前站点运营公司
    thisSiteOperatingCompany: '广州宸祺汽车服务有限公司',
    // 当前站点icp跳转地址
    thisSiteIcpUrl: 'https://beian.miit.gov.cn/#/Integrated/index',
    // 是否展示公网安备
    isShowPublicNetwork: false,
    // 是否展示icp许可证
    isShowIcpPermit: true
  }
};
